import React from "react";

import "./accordion.css";

export const Accard = ({ header, body }) => {
  return (
    <div>
      <div>
        <h1 className="head_11">{ header }</h1>
        <ul>
              { 
                (body)?
                  body.map((item) => { 
                  if(typeof(item)==="string")
                    return(<p className="head_33">{`${item}`}</p>)
                  if(typeof(item)==="object")
                  {
                  for(var field in item) {
                    return(<p className="head_33">{`${field} : ${item[field]}`}</p>)
                  }
                  } 
                })
                :
                null
              }
        </ul>
      </div>
    </div>
  );
};
